var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoCont",style:({ backgroundColor: _vm.info.tips })},[_c('div',{staticClass:"g-box"},[_c('EditCont',{staticClass:"infoCont-bd",attrs:{"content":_vm.info.content}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }